import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import InstagramFeed from './components/InstagramFeed';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SeoHead from '../../components/feature/SeoHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://tadashiconsulting.co.za';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'HomeAndConstructionBusiness',
    name: 'Tadashi Consulting',
    description:
      'Full-service luxury renovation and construction partner specialising in residential and commercial transformations in Johannesburg, South Africa.',
    url: siteUrl,
    telephone: '+27118752075',
    email: 'info@tadashiconsulting.co.za',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '1 Wakis Road, Strydom Park, Block E 1',
      addressLocality: 'Randburg',
      addressRegion: 'Gauteng',
      postalCode: '2194',
      addressCountry: 'ZA',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '-26.0936',
      longitude: '28.0064',
    },
    priceRange: '$$$',
    areaServed: { '@type': 'City', name: 'Johannesburg' },
    sameAs: ['https://www.instagram.com/tadashi_interior_design'],
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Renovation & Construction Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Luxury Residential Renovations' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Commercial Construction & Fit-Outs' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Interior Design' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Structural Upgrades' } },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Tadashi Consulting',
    url: siteUrl,
    description: 'Luxury interior design, renovations and construction in Johannesburg built to perfection.',
  },
];

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Johannesburg Luxury Interior Design & Renovations | Tadashi Consulting"
        description="Tadashi Consulting delivers premium luxury interior design, residential and commercial renovations in Johannesburg. Licensed contractors specialising in high-end finishes, structural upgrades and turnkey construction. Built to perfection."
        keywords="luxury interior design Johannesburg, residential renovations Randburg, commercial construction South Africa, licensed contractors Gauteng, high-end renovations"
        canonical={`${siteUrl}/`}
        ogTitle="Luxury Interior Design & Renovations Built to Perfection | Tadashi Consulting"
        ogDescription="Full-service luxury renovation and construction for discerning homeowners and commercial property owners in Johannesburg. Licensed contractors. Turnkey solutions."
        jsonLd={homeJsonLd}
      />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Process />
      <Testimonials />
      <InstagramFeed />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
